<script setup lang="ts">
import { useRoute } from 'vue-router/composables'
import { brandConfig, resources } from '@/config/brands'
import { useCallApp } from '@/composables/useBannerShow'
import { useElementClick } from '@/composables/tracks'

defineEmits<{ (event: 'close'): void }>()
const config = brandConfig.appBanner?.topBanner
const route = useRoute()
const { callApp } = useCallApp()
const { elementClick } = useElementClick()
function install() {
  const id = route.name === 'book' ? route.params.contentId : undefined
  if (id)
    elementClick(`content:${id}:download`)
  else if (route.name === 'home')
    elementClick('download_app')
  callApp(id)
}
</script>

<template>
  <aside v-if="config" class="top-app-banner">
    <img :src="resources.logo" :alt="config.title" class="top-app-banner__logo">
    <div class="top-app-banner__copy">
      <strong>{{ config.title }}</strong>
      <span>{{ config.subtitle }}</span>
    </div>
    <button class="top-app-banner__install" type="button" @click="install">
      {{ config.installText }}
    </button>
    <button class="top-app-banner__close" type="button" aria-label="Close download banner" @click="$emit('close')">
      <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="m3 3 10 10M13 3 3 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" /></svg>
    </button>
  </aside>
</template>

<style scoped lang="scss">
.top-app-banner {
  height: 60px;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  gap: 10px;
  background: var(--primary-color);
  color: white;
  &__logo { width: 40px; height: 40px; border-radius: 8px; background: white; object-fit: contain; }
  &__copy { margin-left: 8px; flex: 1; min-width: 0; display: flex; flex-direction: column; font-size: 12px; line-height: 18px; }
  strong { font-size: 16px; line-height: 22px; }
  &__install { background: white; color: var(--primary-color); border-radius: 4px; padding: 6px 18px; font-size: 14px; font-weight: 600; }
  &__close { padding: 8px 0 8px 4px; }
}
</style>
